import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import { publish } from '@wh/message-bus';

export var PARTIAL_TRACKING_TOPIC = 'wh.common.command.dli.tl.eventPartial';

export var Tracker = function () {
  function Tracker() {
    _classCallCheck(this, Tracker);
  }

  _createClass(Tracker, [{
    key: 'publishPartialEvent',
    value: function publishPartialEvent(eventName, payload) {
      publish(PARTIAL_TRACKING_TOPIC, {
        event: eventName,
        payload: payload
      });
    }
  }]);

  return Tracker;
}();